/* Hygeon outline gradient icon system — shared draw-on trigger.
   ONE IntersectionObserver for every .hygeon-icon on the page (never
   per-icon), per spec. Idempotent — safe to load from more than one
   section/block that uses snippets/hygeon-icon.liquid. */
(function () {
  if (window.hygeonIconObserverInitialized) return;
  window.hygeonIconObserverInitialized = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);

      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-hg-delay') || '0', 10);

      window.setTimeout(function () {
        el.classList.add('hg-drawn');
        el.querySelectorAll('.hg-drawable').forEach(function (shape) {
          shape.addEventListener('transitionend', function handler() {
            shape.style.strokeDasharray = 'none';
            shape.style.strokeDashoffset = '0';
            shape.removeEventListener('transitionend', handler);
          }, { once: true });
        });
      }, delay);
    });
  }, { threshold: 0.35 });

  document.querySelectorAll('.hygeon-icon[data-hg-animate="true"]').forEach(function (el) {
    observer.observe(el);
  });
})();
